async function request(url, options = {}) {
  const response = await fetch(url, options)
  const body = await response.json().catch(() => ({}))
  if (!response.ok) {
    const error = new Error(body.error || 'Não foi possível concluir a operação')
    error.code = body.code
    error.status = response.status
    throw error
  }
  return body
}

export const api = {
  authStatus: () => request('/api/auth/status'),
  pair: (token) => request('/api/auth/pair', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token }),
  }),
  logout: () => request('/api/auth/logout', { method: 'POST' }),
  listProjects: () => request('/api/projects'),
  getProject: (id) => request(`/api/projects/${encodeURIComponent(id)}`),
  createProject: (data) => request('/api/projects', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  }),
  updateProject: (id, data) => request(`/api/projects/${encodeURIComponent(id)}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  }),
  addCustomization: (id, data) => request(`/api/projects/${encodeURIComponent(id)}/customizations`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  }),
  uploadFiles: (id, files, category = 'references') => {
    const data = new FormData()
    data.append('category', category)
    for (const file of files) data.append('files', file)
    return request(`/api/projects/${encodeURIComponent(id)}/files`, { method: 'POST', body: data })
  },
  openProject: (id) => request(`/api/projects/${encodeURIComponent(id)}/open`, { method: 'POST' }),
  openBambu: (id, relativePath = '') => request(`/api/projects/${encodeURIComponent(id)}/open-bambu`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ relativePath }),
  }),
  listAgentJobs: (limit = 24) => request(`/api/agent/jobs?limit=${limit}`),
  getAgentJob: (id) => request(`/api/agent/jobs/${encodeURIComponent(id)}`),
  createAgentJob: (data) => request('/api/agent/jobs', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  }),
  getIntegrations: () => request('/api/integrations'),
  integrationAction: (data) => request('/api/integrations/action', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  }),
  getSettings: () => request('/api/settings'),
  updateSettings: (data) => request('/api/settings', {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  }),
}
